import React from 'react';
import HeroPrice   from './HeroPrice';
import HeroSignal  from './HeroSignal';
import HeroCompany from './HeroCompany';

const Divider = () => (
  <div style={{ width:'1px', background:'rgba(255,255,255,0.06)', flexShrink:0 }} />
);

export default function HeroCard({
  priceStr, displayChange, displayChangePct, marketClosed, prevCloseStr,
  score, signal, handleShare, shareLoading, shareCopied,
  isLoggedIn, token, ticker, inWatchlist, setInWatchlist, wlLoading, setWlLoading,
  data, memberAnalysis, onNavigate,
}) {
  const effectiveScore  = memberAnalysis?.score          ?? score;
  const effectiveSignal = memberAnalysis?.recommendation ?? signal;

  return (
    <div style={{ display:'flex', flexDirection:'row', marginBottom:'1.5rem',
      background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)',
      borderRadius:'14px', overflow:'hidden' }}>
      <HeroPrice
        priceStr={priceStr}
        displayChange={displayChange}
        displayChangePct={displayChangePct}
        marketClosed={marketClosed}
        prevCloseStr={prevCloseStr}
        quote={data.quote}
        memberAnalysis={memberAnalysis}
        ticker={ticker}
        onNavigate={onNavigate}
        token={token}
      />
      <Divider />
      <HeroSignal
        score={effectiveScore}
        signal={effectiveSignal}
        handleShare={handleShare}
        shareLoading={shareLoading}
        shareCopied={shareCopied}
        isLoggedIn={isLoggedIn}
        token={token}
        ticker={ticker}
        inWatchlist={inWatchlist}
        setInWatchlist={setInWatchlist}
        wlLoading={wlLoading}
        setWlLoading={setWlLoading}
        targetLow={memberAnalysis?.targetLow}
        targetHigh={memberAnalysis?.targetHigh}
        fqScore={memberAnalysis?.fqScore}
        fqGate={memberAnalysis?.fqGate}
        fqDimensions={memberAnalysis?.fqDimensions}
        mqScore={memberAnalysis?.mqScore}
        analystTargetPrice={memberAnalysis?.analystTargetPrice}
        analystVsCurrent={memberAnalysis?.analystVsCurrent}
      />
      <Divider />
      <HeroCompany
        data={data}
        memberAnalysis={memberAnalysis}
      />
    </div>
  );
}
